// extracted by mini-css-extract-plugin
export var quillEditor = "_p7-1";
export var variable = "_p7-0";